import AppReq from '@/h5/utils/appActions/index'
import LGSdk from '@/packages/plugins/languageSDK/index'
import useAppStore from '@/h5/stores/app'
import UnityBridge from '@/h5/utils/appActions/unityBridge'
import { customRequest, baseSecret } from '@/h5/api/activity'
import { randomNum, getTimestamp, getSignedData } from '@/packages/plugins/utils'
import { ref, reactive, onMounted } from 'vue'
import Toast from '@/h5/components/toast'

export const TREASURE_EVENTS = [
  {
    name: 'joinTreasure',
    label: '参与夺宝',
    params: [
      {
        label: '次数',
        value: 'number'
      }
    ]
  },
  {
    name: 'getMoneyBalances',
    label: '刷新货币余额'
  },
  {
    name: 'getPrizeHistory',
    label: '获取活动历史开奖记录'
  }
]

export const TREASURE_DATA_SOURCE = [
  {
    label: '大奖金额',
    keys: 'userTreasure.rewards',
    description: '大奖金额-{count: 数量, type: 类型, contentId: 内容ID}'
  },
  {
    label: '大奖金额-图标',
    keys: 'userTreasure.rewards[].icon'
  },
  {
    label: '大奖金额-数量',
    keys: 'userTreasure.rewards[].count'
  },
  {
    label: '玩家本轮参与次数',
    keys: 'userTreasure.personJoinCount'
  },
  {
    label: '每次参与消耗货币数量',
    keys: 'userTreasure.consumes.count'
  },
  {
    label: '本轮参与次数',
    keys: 'userTreasure.joinCount'
  },
  {
    label: '本轮参与上限',
    keys: 'userTreasure.joinLimit'
  },
  {
    label: '中奖信息',
    keys: 'prizeInfo',
    description: '中奖信息-{count: 数量, type: 类型, contentId: 内容ID}'
  },
  {
    label: '中奖信息-数量',
    keys: 'prizeInfo[].count'
  },
  {
    label: '中奖信息-图标',
    keys: 'prizeInfo[].icon'
  },
  {
    label: '中奖记录',
    keys: 'prizeHistory'
  },
  {
    label: '中奖记录-玩家名',
    keys: 'prizeHistory[].playerName'
  },
  {
    label: '中奖记录-玩家id',
    keys: 'prizeHistory[].playerId'
  },
  {
    label: '代币余额',
    keys: 'moneyBalance'
  },
  {
    label: '代币余额-数量',
    keys: 'moneyBalance[].num'
  },
  {
    label: '代币余额-图标',
    keys: 'moneyBalance[].icon'
  }
]

export const API = {
  /**
   * 获取活动配置
   * @param {*} activityId
   * @returns
   */
  getActivityConfig: (activityId) => {
    const params = {
      id: activityId,
      sign: '',
      appId: 1004,
      timestamp: getTimestamp(),
      random: randomNum(6),
      activityType: 28
    }
    params.sign = getSignedData(params, baseSecret)
    return customRequest(null, '/v1/activityManage/configList', 'get', { 'Content-Type': 'application/json; charset=utf-8' }, params)
  },
  /**
   * 查询是否预加载
   * @param {*} activityId
   * @returns
   */
  getIsPreload: () => {
    return new Promise((resolve) => {
      UnityBridge.callHandler('checkPageInfo', (_, data) => {
        if (_ === false) {
          return resolve(false)
        }
        try {
          const resData = JSON.parse(data)
          return resolve(resData.isPreloadPage)
        } catch (e) {
          console.error(e)
          return resolve(false)
        }
      })
    })
  },
  /**
   * 进度查询
   * @param {*} activityId
   * @param {*} roundId
   * @returns
   */
  getTreasureProgress: (activityId, roundId) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('23', { activityId, roundId })
    } else {
      return null
    }
  },
  /**
   * 参与夺宝
   * @param {*} roundId
   * @param {*} number
   * @returns
   */
  joinTreasure: (roundId, number) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('24', { number, id: roundId })
    } else {
      return null
    }
  },
  /**
   * 历史记录查询
   * @param {*} activityId
   * @returns
   */
  getTreasureHistory: (activityId) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('25', { activityId })
    } else {
      return null
    }
  },
  /**
   * 中奖信息查询
   * @param {*} roundId
   * @returns
   */
  getTreasureRewardInfo: (roundId) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('26', { id: roundId })
    } else {
      return null
    }
  },
  /**
   * 获取用户代币余额
   * @param {*} ids
   * @returns
   */
  getUserCurrencys: (ids) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('1', ids)
    } else {
      return null
    }
  },
  /**
   * 获取用户常量
   * @returns
   */
  getUserConstant: () => {
    return new Promise((resolve) => {
      UnityBridge.callHandler('getUserConstant', (_, data) => {
        let constant = {
          diamond: 0,
          sex: 0,
          coin: 0,
          surpriseCoin: 0
        }
        if (_ === false) {
          return resolve(constant)
        }
        try {
          const params = JSON.parse(data)
          constant = Object.assign(constant, params)
          return resolve(constant)
        } catch (e) {
          console.error(e)
          return resolve(constant)
        }
      })
    })
  }
}

export const useTreasure = (props) => {
  const componentRef = ref(null)
  const appStore = useAppStore ? useAppStore() : null

  // 组件属性
  const state = reactive({
    // 语言
    language: 'en',
    // 组件uuid
    uuid: '',
    // 活动配置
    treasureCfg: {},
    // 轮次ID
    roundId: '',
    // 是否轮询
    isLoopReq: false,
    // 定时器ID
    timerId: null,
    // 数据源
    dataSource: {
      userTreasure: {},
      prizeInfo: [],
      prizeHistory: [],
      moneyBalance: []
    }
  })

  // 获取基础信息-大奖、消耗等
  const getBaseInfo = async () => {
    const bigRewards = []
    // 大奖
    state.treasureCfg?.snatchTreasureReward?.forEach((r) => {
      r.rewards.forEach((r2) => {
        const key = `${r2.type},${r2.contentId}`
        bigRewards.push({
          ...r2,
          icon: props.prizeImages[key].find((item) => item.language === state.language)?.src || ''
        })
      })
    })
    // 消耗
    const consumeConfig = state.treasureCfg?.snatchTreasureConfig.item
    const consumeKey = `${consumeConfig.type},${consumeConfig.contentId}`
    const consumes = {
      ...consumeConfig,
      icon: props.prizeImages[consumeKey].find((item) => item.language === state.language)?.src || ''
    }
    state.dataSource.userTreasure.rewards = bigRewards
    state.dataSource.userTreasure.consumes = consumes
    getMoneyBalances()
  }

  // 获取进度信息
  const getTreasureProgressInfo = async () => {
    try {
      const res = await API.getTreasureProgress(props.activityId, state.roundId || null)
      if (res.data.status !== 1) {
        showErrorTips(res.data.status)
        if ([39002001, 39002002].includes(res.data.status)) {
          stopLoop()
        }
        return
      }

      if (res.data.joinCount === res.data.joinLimit || (state.roundId && state.roundId !== res.data.id)) {
        if (state.dataSource.userTreasure.personJoinCount) {
          getTreasureRewardInfo()
        }
        state.dataSource.userTreasure.joinCount = 0
        state.dataSource.userTreasure.personJoinCount = 0
        state.dataSource.userTreasure.joinLimit = res.data.joinLimit
      } else {
        state.dataSource.userTreasure.joinCount = res.data.joinCount
        state.dataSource.userTreasure.joinLimit = res.data.joinLimit
        state.dataSource.userTreasure.personJoinCount = res.data.personJoinCount
      }
      state.roundId = res.data.id
      appStore.setPageDataSource(state.uuid, state.dataSource || null)
    } catch (e) {
      console.error(e)
    }
  }

  // 获取用户余额信息
  const getMoneyBalances = async () => {
    let money = []
    let moneyMap = {}

    const cfg = state.treasureCfg.snatchTreasureConfig
    const key = cfg.item.type + ',' + cfg.item.contentId
    state.dataSource.userTreasure.consumes.count = cfg.item.count
    moneyMap[key] = 0

    if (moneyMap['0,1'] !== undefined || moneyMap['0,2'] !== undefined || moneyMap['0,3'] !== undefined) {
      const res = await API.getUserConstant()
      if (moneyMap['0,1'] !== undefined) {
        const key = '0,1'
        money.push({
          key: key,
          num: Number(res.coin),
          icon: props.prizeImages[key].find((item) => item.language === state.language)?.src || ''
        })
      }
      if (moneyMap['0,2'] !== undefined) {
        const key = '0,2'
        money.push({
          key,
          num: Number(res.diamond),
          icon: props.prizeImages[key].find((item) => item.language === state.language)?.src || ''
        })
      }
      if (moneyMap['0,3'] !== undefined) {
        const key = '0,3'
        money.push({
          key,
          num: Number(res.surpriseCoin),
          icon: props.prizeImages[key].find((item) => item.language === state.language)?.src || ''
        })
      }
      appStore.setPageDataSource('data-source_userConstant', res || '')
    }
    const ids = Object.keys(moneyMap)
      ?.filter((item) => !['0,1', '0,2', '0,3'].includes(item))
      ?.map((item) => item.split(',')[1])
    if (ids?.length) {
      const res = await API.getUserCurrencys({ ids })
      res?.data?.list?.forEach((item) => {
        const key = '8,' + String(item.id)
        money.push({
          key,
          num: item.count,
          icon: props.prizeImages[key].find((item) => item.language === state.language)?.src || ''
        })
      })
    }
    state.dataSource.moneyBalance = money
    appStore.setPageDataSource(state.uuid, state.dataSource || null)
  }

  // 获取中奖信息
  const getTreasureRewardInfo = async () => {
    try {
      const res = await API.getTreasureRewardInfo(state.roundId)
      if (res.data.status !== 1) {
        showErrorTips(res.data.status)
        return
      }
      const allRewards = []
      res.data?.rewards?.length &&
        res.data.rewards.forEach((r1) => {
          r1.forEach((r2) => {
            allRewards.push(r2)
          })
        })
      state.dataSource.prizeInfo =
        allRewards?.map((reward) => {
          const key = reward.type + ',' + reward.contentId
          const icon = props.prizeImages[key].find((item) => item.language === state.language)?.src || ''
          return {
            ...reward,
            icon
          }
        }) || []
      appStore.setPageDataSource(state.uuid, state.dataSource || null)
      appStore.setNodeAttribute(props.dialogUUID, 'hiden', false)
    } catch (e) {
      console.error(e)
    }
  }

  // 参与夺宝
  const joinTreasure = async (params) => {
    try {
      const joinCount = params.number || 1
      const res = await API.joinTreasure(state.roundId, joinCount)
      if (res.data.status !== 1) {
        showErrorTips(res.data.status)
        if (res.data.status === 39002004) {
          throw new Error('treasure.' + res.data.status)
        }
        return
      }
      getMoneyBalances()
    } catch (e) {
      console.error(e)
      if (e.message === 'treasure.39002004') {
        throw e
      }
    }
  }

  // 历史记录查询
  const getPrizeHistory = async () => {
    try {
      const res = await API.getTreasureHistory(props.activityId)
      if (res.data.status !== 1) {
        showErrorTips(res.data.status)
        return
      }
      state.dataSource.prizeHistory = res?.data?.records || []
      appStore.setPageDataSource(state.uuid, state.dataSource || null)
    } catch (e) {
      console.error(e)
    }
  }

  // 结束轮询
  const stopLoop = () => {
    clearInterval(state.timerId)
    state.isLoopReq = false
    state.timerId = null
  }

  // 页面初始化
  const init = async () => {
    const res = await API.getActivityConfig(props.activityId)
    state.treasureCfg = res?.data?.list[0] || {}
    state.isLoopReq = true
    await getBaseInfo()
    await getTreasureProgressInfo()
    state.timerId = setInterval(() => getTreasureProgressInfo(), props.loopTime * 1000)
    // 判断是否预加载
    API.getIsPreload().then((res) => {
      if (res) {
        // 预加载取消轮询
        stopLoop()
      }
    })
  }

  // 编辑器初始化
  const getConfig = async () => {
    const res = await API.getActivityConfig(props.activityId)
    state.treasureCfg = res?.data?.list[0] || {}
    return res.data || null
  }

  // 显示错误提示
  const showErrorTips = (code) => {
    const statusCodes = [39002001, 39002002, 39002003, 39002004, 39002005]
    let msg = 'error: ' + code
    if (statusCodes.includes(Number(code))) {
      msg = LGSdk.t(`treasure.${code}`)
    }
    Toast && Toast({ message: msg, duration: 1500 })
  }

  onMounted(() => {
    if (componentRef.value) {
      state.language = componentRef.value.getAttribute('language') || 'en'
      state.uuid = componentRef.value.getAttribute('id') || ''
    }
    if (import.meta.env.VITE_APP_TAG === 'H5') {
      init()
    } else {
      getConfig()
    }
  })

  return {
    componentRef,
    getConfig,
    getMoneyBalances,
    joinTreasure,
    getPrizeHistory
  }
}
